import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CheckTransactionRejectResult} from "../../models/transaction/checkTransactionRejectResult.model";

/**
 * Компонент импорта
 */
@Component({
    selector: 'app-check-transactions-reject',
    templateUrl: './checkTransactionRejectResult.component.html'
})
export class CheckTransactionRejectResultComponent implements OnInit {

    @Input() data: CheckTransactionRejectResult;

    constructor(public modal: NgbActiveModal) {
    }

    ngOnInit(): void {
    }



}
